// src/utils/createEmotionCache.js
import createCache from "@emotion/cache";
import stylisRTLPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

const direction = (localStorage.getItem("APP_LANG") === "ar")?"rtl":"ltr";

document.documentElement.setAttribute("dir", direction);
export default function createEmotionCache() {
  return createCache({
    key: direction === "rtl" ? "mui-rtl" : "mui-ltr",
    stylisPlugins: direction === "rtl" ? [prefixer, stylisRTLPlugin] : [],
  });
}
